import React from 'react'
import {Outlet} from 'react-router-dom';
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";

const CustomerOutlet = ({children}) => {
    return <React.Fragment>
        <DashboardLayout>
            {children || <Outlet/>}
        </DashboardLayout>

    </React.Fragment>
};

export default CustomerOutlet;